import React, { Component, useContext } from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import AppContext from "../../AppContext";

function Footer(pros) {
  const context = useContext(AppContext);

  return (
    <div className="footer-div">
      <div className="footer-links pb-4">
        <span className="footer-text">
          A Római tó 2025. március 6.-án ismét megnyitotta a kapuit. Várjuk szeretettel a horgászni és kikapcsolódni
          vágyó embereket.
        </span>
      </div>
      <div className="footer-links">
        <span className="footer-text">Foglalás és információ a következő számon kérhető: +36307494358</span>
      </div>
    </div>
  );
}

export default Footer;
